import $ from "jquery";
import Cookie from "js-cookie";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let $acceptDisclaimer = $( '#accept-disclaimer' );
		let cookieName        = 'accepted_disclaimers';

		if ( $acceptDisclaimer.length ) {
			$acceptDisclaimer.on(
				'click touch',
				function ( e ) {
					let disclaimers = Cookie.get( cookieName, true ) ? JSON.parse( Cookie.get( cookieName, true ) ) : [];
					let id          = $acceptDisclaimer.data( 'id' );

					disclaimers.push( id );
					Cookie.set( cookieName, disclaimers );

					window.location.reload( true );
					return false;
				}
			);
		}
	}
);
